import { useEffect, useState } from "react";
import {
  adminListSubscribers,
  adminDeleteSubscriber,
  adminDownloadSubscribersCsv,
  formatApiErrorDetail,
} from "@/lib/adminApi";

export default function SubscribersPanel() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  const load = async () => {
    try { setRows(await adminListSubscribers()); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  useEffect(() => { load(); }, []);

  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.email} from the list?`)) return;
    try { await adminDeleteSubscriber(s.id); await load(); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  return (
    <section className="admin-subs" data-testid="subscribers-panel">
      <div className="admin-subs__top">
        <p className="mono-caps admin-hint" data-testid="subscribers-count">
          {rows.length} subscriber{rows.length === 1 ? "" : "s"}
        </p>
        <button
          type="button"
          className="admin-btn admin-btn--ghost mono-caps"
          onClick={adminDownloadSubscribersCsv}
          disabled={!rows.length}
          data-testid="subscribers-export"
        >
          Export CSV
        </button>
      </div>
      {error && <p className="admin-error">{error}</p>}
      {rows.length === 0 ? (
        <p className="admin-subs__empty" data-testid="subscribers-empty">No one has signed up yet.</p>
      ) : (
        <table className="admin-table" data-testid="subscribers-table">
          <thead>
            <tr><th className="mono-caps">Email</th><th className="mono-caps">Subscribed</th><th /></tr>
          </thead>
          <tbody>
            {rows.map((s) => (
              <tr key={s.id} data-testid={`subscriber-row-${s.email}`}>
                <td>{s.email}</td>
                <td className="mono-caps">{new Date(s.created_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}</td>
                <td><button type="button" className="admin-mini admin-mini--danger mono-caps" onClick={() => remove(s)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
